import { DataTableProps, DataTableTypes } from '../../DataTableTypes';
import { dataTableDefaultProps } from '../const/defaultValues';

export function getDerivedState(props: DataTableProps<any, any, any>): DataTableTypes.DerivedState<any> {
  const backendDrivenModel = 'model' in props;
  const limit = props.model?.page?.limit || dataTableDefaultProps.limit;
  const offset = props.model?.page?.offset || dataTableDefaultProps.offset;
  const totalCount = backendDrivenModel
    ? props.model?.page?.totalCount || dataTableDefaultProps.totalCount
    : props.data.length;
  const loading = props.loading ?? dataTableDefaultProps.loading;
  const variant = props.variant ?? 'default';

  return {
    ui: {
      variant,
      show: {
        toolbar: variant === 'default'
      }
    },
    state: {
      loading,
      loadingInBackground: props?.loadingInBackground ?? false
    },
    features: {
      selectable: props.selectable ? { enabled: true, key: props.selectable } : { enabled: false, key: undefined },
      expandable: props.expandable ? { enabled: true, key: props.expandable } : { enabled: false, key: undefined },
      columnManagement: {
        enabled: !!props.onColumnConfigurationChange,
        resizable:
          !!props.onColumnConfigurationChange && !!props.resizable
            ? {
                enabled: true,
                mode: 'onChange',
                direction: 'ltr'
              }
            : {
                enabled: false,
                mode: undefined,
                direction: undefined
              }
      }
    },
    pageModel: {
      totalCount,
      limit,
      offset,
      currentPage: Math.floor(offset / limit)
    }
  };
}
